<div class="widget_box" *ngIf="isCardPayment === false; else card" [ngStyle]="{ 'border-color': getColor() }">
	<span *ngFor="let item of items" [ngClass]="{ saldo_box: item.boldBlue === true }">
		<h5 *ngIf="item.boldBlue === undefined || item.boldBlue === false">
			{{ item.title }}
		</h5>
		<h5 *ngIf="item.boldBlue === true">
			<strong>{{ item.title }}</strong>
		</h5>

		<p>{{ item.subTitle }}</p>
	</span>
</div>

<ng-template #card>
	<div *ngFor="let item of items">
		<div class="widget_box widget_tarjeta" *ngIf="item.title !== ''">
			<h4>{{ item.title }}</h4>
			<p>{{ item.subTitle }}</p>
		</div>
	</div>
</ng-template>
